<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Feathered Friends</h1>
<p class="BOD2">In a flap over gift ideas? Check out this flock of fabulous birds – make a very special one or a whole nestful…</p>
<p class="IMAGE"><img alt="" src="images/C1-23.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-24.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-12.vue?017a58b7